<h2>Promotion</h2>
<app-promotion [userInfos]="userInfos" [promotionData]="dataSource" [productData]="products" [platformInfos]="platformInfos"></app-promotion>
